import * as React from "react";
const SvgRandom = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "currentColor", stroke: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8,8h9v22h-9zm13,0h9v22h-9z M45,8l11,11l-11,11l-11,-11z M8,56l11,-22l11,22z M34,34h22v22h-22z" }));
export default SvgRandom;
